import "./Home.scss";
import Hero from "../../components/Hero/Hero";
import TopBox from "../../components/TopBox/TopBox";
import MiddleBox from "../../components/MiddleBox/MiddleBox";
import BottomBox from "../../components/BottomBox/BottomBox";
import Images from "../../components/Images/Images";

const Home = () => {
  return (
    <div>
      <Hero />
      <div className="home">
        <TopBox />
        <MiddleBox />
        <BottomBox />
      </div>
      <div>
        <Images />
      </div>
    </div>
  );
};

export default Home;
